import type { AuthResponse, UsageState, UserDTO } from '@copilot/shared';
import { api } from './client';

export const authApi = {
  login: (email: string, password: string) =>
    api<AuthResponse>('/auth/login', { method: 'POST', body: { email, password, client: 'web' } }),
  /**
   * `client` is not part of SignupBodySchema (zod strips it), but the server
   * reads it to decide cookie vs body for the refresh token, as on login.
   */
  signup: (email: string, password: string, name: string) =>
    api<AuthResponse>('/auth/signup', { method: 'POST', body: { email, password, name, client: 'web' } }),
  logout: () => api<void>('/auth/logout', { method: 'POST', body: {} }),
  me: () => api<UserDTO>('/me'),
  myUsage: () => api<UsageState>('/me/usage'),
};
